export default {
  "hierarchy": {
    "iconBig": [
      "toggleButton-iconBig"
    ],
    "iconMedium": [
      "toggleButton-iconBig",
      "toggleButton-iconMedium"
    ],
    "iconSmall": [
      "toggleButton-iconBig",
      "toggleButton-iconMedium",
      "toggleButton-iconSmall"
    ],
    "actions": [
      "toggleButton-actions"
    ],
    "nav": [
      "toggleButton-nav"
    ],
    "navSubItem": [
      "toggleButton-nav",
      "toggleButton-navSubItem"
    ],
    "navCollapsed": [
      "toggleButton-nav",
      "toggleButton-navCollapsed"
    ],
    "navSecondary": [
      "toggleButton-nav",
      "toggleButton-navSecondary"
    ],
    "navSecondaryMobile": [
      "toggleButton-nav",
      "toggleButton-navSecondary",
      "toggleButton-navSecondaryMobile"
    ],
    "mobile": [
      "toggleButton-mobile"
    ],
    "mobileSearch": [
      "toggleButton-mobile",
      "toggleButton-mobileSearch"
    ],
    "mobileDateRange": [
      "toggleButton-mobileDateRange"
    ],
    "selector": [
      "toggleButton-actions",
      "toggleButton-selector"
    ],
    "itemBar": [
      "toggleButton-itemBar"
    ],
    "topNavBar": [
      "toggleButton-topNavBar"
    ],
    "sideNavBar": [
      "toggleButton-sideNavBar"
    ],
    "navBar": [
      "toggleButton-navBar"
    ],
    "hNavBar": [
      "toggleButton-topNavBar",
      "toggleButton-hNavBar"
    ],
    "navBarMenu": [
      "toggleButton-topNavBar",
      "toggleButton-hNavBar",
      "toggleButton-topNavBarMenu",
      "toggleButton-navBarMenu"
    ],
    "hNavBarMenu": [
      "toggleButton-topNavBar",
      "toggleButton-hNavBar",
      "toggleButton-topNavBarMenu",
      "toggleButton-hNavBarMenu"
    ],
    "settings": [
      "toggleButton-iconBig",
      "toggleButton-iconMedium",
      "toggleButton-settings"
    ],
    "actionBar": [
      "toggleButton-itemBar",
      "toggleButton-actionBar"
    ],
    "link": [
      "toggleButton-link"
    ],
    "mapActionBar": [
      "toggleButton-itemBar",
      "toggleButton-actionBar",
      "toggleButton-mapActionBar"
    ],
    "mobileNavBar": [
      "toggleButton-sideNavBar",
      "toggleButton-mobileNavBar"
    ],
    "mobileUserNavBar": [
      "toggleButton-sideNavBar",
      "toggleButton-mobileNavBar",
      "toggleButton-mobileUserNavBar"
    ],
    "dashboardEdit": [
      "toggleButton-link",
      "toggleButton-dashboardEdit"
    ],
    "sideNavBarSmall": [
      "toggleButton-sideNavBar",
      "toggleButton-sideNavBarSmall"
    ],
    "touchToolbarPopupToggle": [
      "toggleButton-link",
      "toggleButton-touchToolbarPopupToggle"
    ],
    "twoStepToggle": [
      "toggleButton-twoStepToggle"
    ],
    "condition": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-multiSelector",
      "toggleButton-condition"
    ],
    "sideNavBarCollapse": [
      "toggleButton-sideNavBarCollapse"
    ],
    "sideNavBarCollapseSmall": [
      "toggleButton-sideNavBarCollapse",
      "toggleButton-sideNavBarCollapseSmall"
    ],
    "layoutActionMobileOptBar": [
      "toggleButton-sideNavBar",
      "toggleButton-mobileNavBar",
      "toggleButton-layoutActionMobileOptBar"
    ],
    "layoutActionBarSubmenu": [
      "toggleButton-layoutActionBarSubmenu"
    ],
    "layoutSelector": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-layoutSelector"
    ],
    "mobileNavBarNested": [
      "toggleButton-sideNavBar",
      "toggleButton-mobileNavBar",
      "toggleButton-mobileNavBarNested"
    ],
    "itemBarMobile": [
      "toggleButton-itemBar",
      "toggleButton-itemBarMobile"
    ],
    "inputSelector": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-multiSelector",
      "toggleButton-inputSelector"
    ],
    "multiSelector": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-multiSelector"
    ],
    "mapActionBarMenu": [
      "toggleButton-mapActionBarMenu"
    ],
    "mobileUserNavBarNested": [
      "toggleButton-sideNavBar",
      "toggleButton-mobileNavBar",
      "toggleButton-mobileNavBarNested",
      "toggleButton-mobileUserNavBarNested"
    ],
    "mobileActionBar": [
      "toggleButton-mobileActionBar"
    ],
    "sortFilterBar": [
      "toggleButton-sortFilterBar"
    ],
    "filter": [
      "toggleButton-sortFilterBar",
      "toggleButton-filter"
    ],
    "logicConditionSelector": [
      "toggleButton-conditionSelector",
      "toggleButton-logicConditionSelector"
    ],
    "logicConditionOperator": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-logicConditionOperator"
    ],
    "linkNoPad": [
      "toggleButton-link",
      "toggleButton-linkNoPad"
    ],
    "sort": [
      "toggleButton-sortFilterBar",
      "toggleButton-sort"
    ],
    "linkNeutral": [
      "toggleButton-link",
      "toggleButton-linkNeutral"
    ],
    "linkNeutralNoPad": [
      "toggleButton-link",
      "toggleButton-linkNeutral",
      "toggleButton-linkNeutralNoPad"
    ],
    "conditionSelector": [
      "toggleButton-conditionSelector"
    ],
    "comparator": [
      "toggleButton-conditionSelector",
      "toggleButton-comparator"
    ],
    "quaternary": [
      "toggleButton-quaternary"
    ],
    "conditionBarMenu": [
      "toggleButton-itemBar",
      "toggleButton-actionBar",
      "toggleButton-conditionBarMenu"
    ],
    "attributeTableEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeTableEditor"
    ],
    "mobileTopNavBar": [
      "toggleButton-mobileTopNavBar"
    ],
    "viewerSelector": [
      "toggleButton-iconBig",
      "toggleButton-iconMedium",
      "toggleButton-viewerSelector"
    ],
    "attributeEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeEditor"
    ],
    "conditionPropertyCondition": [
      "toggleButton-conditionSelector",
      "toggleButton-conditionPropertyCondition"
    ],
    "templateEditorActionBar": [
      "toggleButton-itemBar",
      "toggleButton-actionBar",
      "toggleButton-templateEditorActionBar"
    ],
    "valueSourcePill": [
      "toggleButton-valueSourcePill"
    ],
    "addCard": [
      "toggleButton-itemBar",
      "toggleButton-actionBar",
      "toggleButton-addCard"
    ],
    "actionBarDashboardMenu": [
      "toggleButton-itemBar",
      "toggleButton-actionBar",
      "toggleButton-actionBarDashboardMenu"
    ],
    "userTopNavBarMenu": [
      "toggleButton-topNavBar",
      "toggleButton-userTopNavBarMenu"
    ],
    "mobileOptBar": [
      "toggleButton-sideNavBar",
      "toggleButton-mobileNavBar",
      "toggleButton-mobileOptBar"
    ],
    "mobileOptBarNested": [
      "toggleButton-sideNavBar",
      "toggleButton-mobileNavBar",
      "toggleButton-mobileOptBar",
      "toggleButton-mobileOptBarNested"
    ],
    "pairingSelector": [
      "toggleButton-pairingSelector"
    ],
    "arrayMore": [
      "toggleButton-arrayMore"
    ],
    "customText": [
      "toggleButton-customText"
    ],
    "attributeTableSelectorEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeTableSelectorEditor"
    ],
    "attributeTableParentEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeTableSelectorEditor",
      "toggleButton-attributeTableParentEditor"
    ],
    "attributeTableEnumEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeTableSelectorEditor",
      "toggleButton-attributeTableParentEditor",
      "toggleButton-attributeTableEnumEditor"
    ],
    "attributeTableResourceEnumEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeTableSelectorEditor",
      "toggleButton-attributeTableParentEditor",
      "toggleButton-attributeTableEnumEditor",
      "toggleButton-attributeTableResourceEnumEditor"
    ],
    "radioSelector": [
      "toggleButton-radioSelector"
    ],
    "radioSelectorFirst": [
      "toggleButton-radioSelector",
      "toggleButton-radioSelectorFirst"
    ],
    "radioSelectorLast": [
      "toggleButton-radioSelector",
      "toggleButton-radioSelectorLast"
    ],
    "radioSelectorSmall": [
      "toggleButton-radioSelector",
      "toggleButton-radioSelectorSmall"
    ],
    "radioSelectorSmallFirst": [
      "toggleButton-radioSelector",
      "toggleButton-radioSelectorFirst",
      "toggleButton-radioSelectorSmallFirst"
    ],
    "radioSelectorSmallLast": [
      "toggleButton-radioSelector",
      "toggleButton-radioSelectorLast",
      "toggleButton-radioSelectorSmallLast"
    ],
    "attributeDetailSelectorEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeTableSelectorEditor",
      "toggleButton-attributeDetailSelectorEditor"
    ],
    "attributeDetailEnumEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeTableSelectorEditor",
      "toggleButton-attributeTableParentEditor",
      "toggleButton-attributeTableEnumEditor",
      "toggleButton-attributeDetailEnumEditor"
    ],
    "attributeDetailParentEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-attributeTableSelectorEditor",
      "toggleButton-attributeTableParentEditor",
      "toggleButton-attributeDetailParentEditor"
    ],
    "attributeDetailBooleanEditor": [
      "toggleButton-attributeDetailBooleanEditor"
    ],
    "customTextMenu": [
      "toggleButton-itemBar",
      "toggleButton-actionBar",
      "toggleButton-customTextMenu"
    ],
    "attributeSuffix": [
      "toggleButton-attributeSuffix"
    ],
    "tvSideNavBar": [
      "toggleButton-sideNavBar",
      "toggleButton-tvSideNavBar"
    ],
    "operatingHoursDay": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-operatingHoursDay"
    ],
    "aggregationLabel": [
      "toggleButton-link",
      "toggleButton-linkNoPad",
      "toggleButton-aggregationLabel"
    ],
    "aggregationTitle": [
      "toggleButton-link",
      "toggleButton-linkNoPad",
      "toggleButton-aggregationLabel",
      "toggleButton-aggregationTitle"
    ],
    "aggregation": [
      "toggleButton-aggregation"
    ],
    "rsrcActionBar": [
      "toggleButton-itemBar",
      "toggleButton-actionBar",
      "toggleButton-rsrcActionBar"
    ],
    "rsrcActionBarMenu": [
      "toggleButton-itemBar",
      "toggleButton-actionBar",
      "toggleButton-rsrcActionBar",
      "toggleButton-rsrcActionBarMenu"
    ],
    "sortFilterToolbar": [
      "toggleButton-sortFilterBar",
      "toggleButton-sortFilterToolbar"
    ],
    "sortFilterToolbarRight": [
      "toggleButton-sortFilterBar",
      "toggleButton-sortFilterToolbar",
      "toggleButton-sortFilterToolbarRight"
    ],
    "videoControls": [
      "toggleButton-videoControls"
    ],
    "layerToolbar": [
      "toggleButton-layerToolbar"
    ],
    "videoPlayBar": [
      "toggleButton-videoControls",
      "toggleButton-videoPlayBar"
    ],
    "dropdown": [
      "toggleButton-itemBar",
      "toggleButton-dropdown"
    ],
    "videoPtzPresets": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-videoPtzPresets"
    ],
    "collectionEditorCollapse": [
      "toggleButton-itemBar",
      "toggleButton-collectionEditorCollapse"
    ],
    "topNavBarMenu": [
      "toggleButton-topNavBar",
      "toggleButton-hNavBar",
      "toggleButton-topNavBarMenu"
    ],
    "tableFilter": [
      "toggleButton-tableFilter"
    ],
    "salesFlowType": [
      "toggleButton-salesFlowType"
    ],
    "salesFlowNewCustomer": [
      "toggleButton-salesFlowNewCustomer"
    ],
    "pill": [
      "toggleButton-pill"
    ],
    "pillWarning": [
      "toggleButton-pill",
      "toggleButton-pillWarning"
    ],
    "pillDTC": [
      "toggleButton-pill",
      "toggleButton-pillWarning",
      "toggleButton-pillDTC"
    ],
    "pillPrimary": [
      "toggleButton-pill",
      "toggleButton-pillPrimary"
    ],
    "pillError": [
      "toggleButton-pill",
      "toggleButton-pillError"
    ],
    "pillSuccess": [
      "toggleButton-pill",
      "toggleButton-pillSuccess"
    ],
    "pillTheftActive": [
      "toggleButton-pill",
      "toggleButton-pillError",
      "toggleButton-pillTheftActive"
    ],
    "pillTheftEnding": [
      "toggleButton-pill",
      "toggleButton-pillTheftEnding"
    ],
    "pillLowBattery": [
      "toggleButton-pill",
      "toggleButton-pillError",
      "toggleButton-pillLowBattery"
    ],
    "attributeParentEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-multiSelector",
      "toggleButton-inputSelector",
      "toggleButton-attributeParentEditor"
    ],
    "secondaryButton": [
      "toggleButton-secondaryButton"
    ],
    "positionDetailRenderer": [
      "toggleButton-positionDetailRenderer"
    ],
    "attributeEnumEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-multiSelector",
      "toggleButton-inputSelector",
      "toggleButton-attributeEnumEditor"
    ],
    "attributeResourceEnumEditor": [
      "toggleButton-actions",
      "toggleButton-selector",
      "toggleButton-multiSelector",
      "toggleButton-inputSelector",
      "toggleButton-attributeResourceEnumEditor"
    ],
    "pillTag": [
      "toggleButton-pill",
      "toggleButton-pillTag"
    ],
    "primary": [
      "toggleButton-primary"
    ],
    "tablePill": [
      "toggleButton-pill",
      "toggleButton-tablePill"
    ],
    "detailSecondary": [
      "toggleButton-secondaryButton",
      "toggleButton-detailSecondary"
    ],
    "pillTagWarning": [
      "toggleButton-pill",
      "toggleButton-pillWarning",
      "toggleButton-pillTagWarning"
    ]
  },
  "props": {
    "default": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "iconBig": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "iconMedium": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "iconSmall": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "actions": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "iconOff": "lv lv-chevron-down",
      "iconOn": "lv lv-chevron-up"
    },
    "nav": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "navSubItem": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "navCollapsed": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "navSecondary": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "navSecondaryMobile": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "mobile": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "mobileSearch": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "mobileDateRange": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "selector": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "itemBar": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "imageOpts": {
        "height": "",
        "width": ""
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "topNavBar": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "height": "24",
        "width": "24"
      }
    },
    "sideNavBar": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "width": "20"
      }
    },
    "navBar": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "hNavBar": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "height": "24",
        "width": "24"
      }
    },
    "navBarMenu": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "height": "24",
        "width": "24"
      },
      "iconOff": "lv lv-chevron-down",
      "iconOn": "lv lv-chevron-up",
      "iconPosition": ""
    },
    "hNavBarMenu": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "height": "24",
        "width": "24"
      },
      "iconOff": "lv lv-chevron-down",
      "iconOn": "lv lv-chevron-up",
      "iconPosition": ""
    },
    "settings": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "actionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "link": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "mapActionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "width": "20px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "mobileNavBar": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "iconOffOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "iconOnOpts": {
        "style": {
          "fontSize": "24px"
        }
      }
    },
    "mobileUserNavBar": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base700)"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "iconOffOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "iconOnOpts": {
        "style": {
          "fontSize": "24px"
        }
      }
    },
    "dashboardEdit": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "sideNavBarSmall": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "width": "20"
      }
    },
    "touchToolbarPopupToggle": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "twoStepToggle": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "condition": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "iconOff": "null",
      "iconOn": "null",
      "icon": "null",
      "iconPosition": "null"
    },
    "sideNavBarCollapse": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "https://recovr-ui-assets.storage.googleapis.com/chevron-left-blue.png",
      "iconOff": "https://recovr-ui-assets.storage.googleapis.com/chevron-left-blue.png",
      "iconOn": "https://recovr-ui-assets.storage.googleapis.com/chevron-left-blue.png",
      "imageOpts": {
        "width": "24px"
      }
    },
    "sideNavBarCollapseSmall": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "https://recovr-ui-assets.storage.googleapis.com/chevron-right-blue.png",
      "iconOff": "https://recovr-ui-assets.storage.googleapis.com/chevron-right-blue.png",
      "iconOn": "https://recovr-ui-assets.storage.googleapis.com/chevron-right-blue.png",
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "layoutActionMobileOptBar": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "iconOffOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "iconOnOpts": {
        "style": {
          "fontSize": "24px"
        }
      }
    },
    "layoutActionBarSubmenu": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "layoutSelector": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "iconOff": "@icon:chevronUp",
      "iconOn": "@icon:chevronDown",
      "icon": "@icon:chevronDown"
    },
    "mobileNavBarNested": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "iconOffOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "iconOnOpts": {
        "style": {
          "fontSize": "24px"
        }
      }
    },
    "itemBarMobile": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "imageOpts": {
        "height": "",
        "width": ""
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "inputSelector": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "multiSelector": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "mapActionBarMenu": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "imageOpts": {
        "width": "20px"
      }
    },
    "mobileUserNavBarNested": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "iconOffOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "iconOnOpts": {
        "style": {
          "fontSize": "24px"
        }
      }
    },
    "mobileActionBar": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "sortFilterBar": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "filter": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "logicConditionSelector": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "imageOpts": {
        "height": "20px",
        "width": "20px"
      }
    },
    "logicConditionOperator": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "linkNoPad": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "sort": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "linkNeutral": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "linkNeutralNoPad": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "conditionSelector": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "comparator": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "quaternary": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "conditionBarMenu": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "attributeTableEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "mobileTopNavBar": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "viewerSelector": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "attributeEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "conditionPropertyCondition": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "templateEditorActionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "valueSourcePill": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "addCard": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "actionBarDashboardMenu": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "userTopNavBarMenu": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base700)"
        }
      },
      "imageOpts": {
        "height": "24",
        "width": "24"
      }
    },
    "mobileOptBar": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "iconOffOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "iconOnOpts": {
        "style": {
          "fontSize": "24px"
        }
      }
    },
    "mobileOptBarNested": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "iconOffOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "iconOnOpts": {
        "style": {
          "fontSize": "24px"
        }
      }
    },
    "pairingSelector": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "arrayMore": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "customText": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "attributeTableSelectorEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fa fa-chevron-down",
      "iconOn": "fa fa-chevron-up",
      "iconOffOpts": null,
      "iconPosition": "end"
    },
    "attributeTableParentEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fa fa-chevron-down",
      "iconOn": "fa fa-chevron-up",
      "iconOffOpts": null,
      "iconPosition": "end"
    },
    "attributeTableEnumEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fa fa-chevron-down",
      "iconOn": "fa fa-chevron-up",
      "iconOffOpts": null,
      "iconPosition": "end"
    },
    "attributeTableResourceEnumEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fa fa-chevron-down",
      "iconOn": "fa fa-chevron-up",
      "iconOffOpts": null,
      "iconPosition": "end"
    },
    "radioSelector": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "radioSelectorFirst": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "radioSelectorLast": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "radioSelectorSmall": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "radioSelectorSmallFirst": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "radioSelectorSmallLast": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "attributeDetailSelectorEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fa fa-chevron-down",
      "iconOn": "fa fa-chevron-up",
      "iconOffOpts": null,
      "iconPosition": "end"
    },
    "attributeDetailEnumEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fa fa-chevron-down",
      "iconOn": "fa fa-chevron-up",
      "iconOffOpts": null,
      "iconPosition": "end"
    },
    "attributeDetailParentEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fa fa-chevron-down",
      "iconOn": "fa fa-chevron-up",
      "iconOffOpts": null,
      "iconPosition": "end"
    },
    "attributeDetailBooleanEditor": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "customTextMenu": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "attributeSuffix": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "tvSideNavBar": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "width": "20"
      }
    },
    "operatingHoursDay": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "aggregationLabel": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "aggregationTitle": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "aggregation": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "rsrcActionBar": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "rsrcActionBarMenu": {
      "iconOpts": {
        "style": {
          "fontSize": "16px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "sortFilterToolbar": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "sortFilterToolbarRight": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "videoControls": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "layerToolbar": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "videoPlayBar": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "dropdown": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "imageOpts": {
        "height": "",
        "width": ""
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "videoPtzPresets": {
      "iconOpts": {
        "style": {
          "fontSize": "14px",
          "padding": ""
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "collectionEditorCollapse": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "imageOpts": {
        "height": "",
        "width": ""
      },
      "imageOffOpts": {
        "height": "",
        "width": ""
      },
      "imageOnOpts": {
        "height": "",
        "width": ""
      }
    },
    "topNavBarMenu": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "imageOpts": {
        "height": "24",
        "width": "24"
      },
      "iconOff": "lv lv-chevron-down",
      "iconOn": "lv lv-chevron-up",
      "iconPosition": ""
    },
    "tableFilter": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-solid fa-filter-list",
      "iconOff": "fa-solid fa-filter-list",
      "iconOn": "fa-solid fa-filter-list"
    },
    "salesFlowType": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "salesFlowNewCustomer": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "pill": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "pillWarning": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "pillDTC": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "https://storage.googleapis.com/recovr-ui-assets/obd-icon.svg"
    },
    "pillPrimary": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "pillError": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "pillSuccess": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "pillTheftActive": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "https://recovr-ui-assets.storage.googleapis.com/theft-recovery-pill-active-2.png",
      "imageOpts": {
        "width": "20"
      }
    },
    "pillTheftEnding": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "https://recovr-ui-assets.storage.googleapis.com/theft-recovery-pill-ending-2.png",
      "imageOpts": {
        "width": "20"
      }
    },
    "pillLowBattery": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-regular fa-battery-bolt"
    },
    "attributeParentEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "secondaryButton": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "positionDetailRenderer": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fak fa-lv-link-out"
    },
    "attributeEnumEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "attributeResourceEnumEditor": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "iconOff": "fak fa-lv-chevron-down-small",
      "iconOn": "fak fa-lv-chevron-up-small"
    },
    "pillTag": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-kit fa-lv-recovr-tag"
    },
    "primary": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "tablePill": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "detailSecondary": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      }
    },
    "pillTagWarning": {
      "iconOpts": {
        "style": {
          "color": ""
        }
      },
      "icon": "fa-kit fa-lv-recovr-tag"
    }
  }
}